import styled from 'styled-components'

const backgroundHeader = require('../../../../assets/img/brand/full_logo.png')

export const Container = styled.div`
    min-height: 590px; 
    background-size: cover; 
    background-position: center top;
    /* background-image: url('../icon.png') */
`

export const LoadingContainer = styled.div`
   flex: 1;
   display: flex;
   height: 100%;
   justify-content: center;
   align-items: center;
`

export const Gradient = styled.samp`

`